import React from 'react';
import './PetAnimations.css';

export default function AllaySvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#6CB8E8';
  const lightColor = color ? lighten(color) : '#A0D8F8';
  const darkColor = color ? darken(color) : '#4090C0';
  const glowColor = 'rgba(120, 200, 255, 0.3)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Glow aura */}
      <circle cx="60" cy="52" r="40" fill={glowColor} />
      <circle cx="60" cy="52" r="32" fill="rgba(140, 210, 255, 0.2)" />
      {/* Wings (translucent) */}
      <path d="M34 46C24 36 20 28 24 24C28 20 34 28 38 38" fill="rgba(160, 220, 255, 0.4)" stroke="rgba(120, 200, 255, 0.6)" strokeWidth="0.8" />
      <path d="M32 52C22 48 14 44 14 38C16 34 22 40 30 48" fill="rgba(160, 220, 255, 0.35)" stroke="rgba(120, 200, 255, 0.5)" strokeWidth="0.8" />
      <path d="M86 46C96 36 100 28 96 24C92 20 86 28 82 38" fill="rgba(160, 220, 255, 0.4)" stroke="rgba(120, 200, 255, 0.6)" strokeWidth="0.8" />
      <path d="M88 52C98 48 106 44 106 38C104 34 98 40 90 48" fill="rgba(160, 220, 255, 0.35)" stroke="rgba(120, 200, 255, 0.5)" strokeWidth="0.8" />
      {/* Body */}
      <ellipse cx="60" cy="56" rx="20" ry="22" fill={bodyColor} />
      {/* Body highlight */}
      <ellipse cx="56" cy="52" rx="12" ry="14" fill={lightColor} opacity="0.5" />
      {/* Head */}
      <ellipse cx="60" cy="34" rx="16" ry="14" fill={bodyColor} />
      {/* Head highlight */}
      <ellipse cx="56" cy="32" rx="10" ry="8" fill={lightColor} opacity="0.4" />
      {/* Eyes */}
      <circle cx="54" cy="32" r="3.5" fill="white" />
      <circle cx="66" cy="32" r="3.5" fill="white" />
      <circle cx="55" cy="32" r="2" fill="#2060A0" />
      <circle cx="67" cy="32" r="2" fill="#2060A0" />
      <circle cx="55.5" cy="31" r="0.8" fill="white" />
      <circle cx="67.5" cy="31" r="0.8" fill="white" />
      {/* Mouth */}
      <path d="M57 38C58 39 62 39 63 38" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Arms */}
      <path d="M42 52C38 56 36 62 38 66" stroke={bodyColor} strokeWidth="4" strokeLinecap="round" fill="none" />
      <path d="M78 52C82 56 84 62 82 66" stroke={bodyColor} strokeWidth="4" strokeLinecap="round" fill="none" />
      {/* Hands holding item */}
      <circle cx="38" cy="68" r="3" fill={lightColor} />
      <circle cx="82" cy="68" r="3" fill={lightColor} />
      {/* Held item (tiny heart) */}
      <path d="M56 72C56 70 58 68 60 70C62 68 64 70 64 72C64 75 60 78 60 78C60 78 56 75 56 72Z" fill="#FF6688" opacity="0.8" />
      {/* Sparkle particles */}
      <circle cx="40" cy="30" r="1" fill="white" opacity="0.7" />
      <circle cx="82" cy="44" r="1.2" fill="white" opacity="0.6" />
      <circle cx="46" cy="70" r="0.8" fill="white" opacity="0.5" />
      <circle cx="76" cy="62" r="1" fill="white" opacity="0.6" />
      {/* Tiny legs */}
      <path d="M54 76L52 84" stroke={bodyColor} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M66 76L68 84" stroke={bodyColor} strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
